import { useQuery } from '@apollo/react-hooks';
import {
  Compaigns,
  CompaignsVariables,
} from '../../graphql/compaign/types/Compaigns';
import { GET_COMPAIGNS } from '../../graphql/compaign/query';

export const useGetCompaigns = () => {
  return useQuery<Compaigns, CompaignsVariables>(GET_COMPAIGNS, {
    fetchPolicy: 'cache-and-network',
  });
};
